import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/external_link.svg'


const _withScopeId = n => (_pushScopeId("data-v-597fed81"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "overview-table" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Date", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Begin", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "End", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Course", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "City", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Athletes / Synced", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Entries", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Relays", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Meet Invitation", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"padding-left":"5px"},
  src: _imports_0,
  width: "12",
  height: "12"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "overview-table"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Scores")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Score", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pull_refresh = _resolveComponent("pull-refresh")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.main)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.main.name), 1),
          _createVNode(_component_pull_refresh, {
            modelValue: _ctx.isloading,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isloading) = $event)),
            onRefresh: _ctx.onRefresh,
            "pulling-text": "",
            "loosing-text": "update...",
            "loading-text": "fetch...",
            "success-text": "done"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "center",
                src: _ctx.filename,
                onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onImgError()))
              }, null, 40, _hoisted_1),
              _hoisted_2,
              _createElementVNode("table", _hoisted_3, [
                _createElementVNode("tbody", null, [
                  (_ctx.main.startdate == _ctx.main.enddate)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("td", null, _toDisplayString(_ctx.get_formated_date_from_date(_ctx.main.startdate)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("tr", null, [
                          _hoisted_6,
                          _createElementVNode("td", null, _toDisplayString(_ctx.get_formated_date_from_date(_ctx.main.startdate)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_7,
                          _createElementVNode("td", null, _toDisplayString(_ctx.get_formated_date_from_date(_ctx.main.enddate)), 1)
                        ])
                      ], 64)),
                  _createElementVNode("tr", null, [
                    _hoisted_8,
                    _createElementVNode("td", null, _toDisplayString(_ctx.get_course_from_course_id(_ctx.main.course)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_9,
                    _createElementVNode("td", null, _toDisplayString(_ctx.main.city), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_10,
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, { to: {
                    name: 'Swimstats',
                    params: {},
                  } }, {
                        default: _withCtx(() => [
                          _createTextVNode(" ⓘ " + _toDisplayString(_ctx.main.statistic.athletes) + " / " + _toDisplayString(_ctx.get_synchronized_athletes()), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    _createElementVNode("td", null, _toDisplayString(_ctx.main.statistic.entries), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_12,
                    _createElementVNode("td", null, _toDisplayString(_ctx.main.statistic.relays), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: 
                    'https://www.swimrankings.net/index.php?page=CalendarDetail&SwrId=' +
                    _ctx.$route.params.meetid
                  
                      }, [
                        _createTextVNode("swimrankings.net"),
                        _hoisted_15
                      ], 8, _hoisted_14)
                    ])
                  ])
                ])
              ]),
              _hoisted_16,
              (_ctx.main.pointscores && _ctx.main.pointscores.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.main.pointscores, (pointscore) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: pointscore.id
                        }, [
                          _hoisted_19,
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: {
                    name: 'Pointscore',
                    params: {
                      meetid: _ctx.$route.params.meetid,
                      pointscoreid: String(pointscore.id),
                    },
                  }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(pointscore.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}